<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>新規来店予約申し込み登録</h1>
          </section>

          <section class="p-bloc p-bloc__call p-bloc__call--step1">
            <h3>お急ぎの方はお電話でご連絡ください</h3>
            <div class="telnum"><span>0120-17-7109</span></div>
            <h4>24時間受付中</h4>
          </section>

          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">STEP 1</h2>

            <div class="p-reservation__bloc">
              <p>プロフィール情報を入力してください。</p>

              <div class="p-reservation__form">
                <dl class="c-form-parts">
                  <dt>お名前</dt>
                  <dd>
                    <ul class="input-area">
                      <li>
                        <input-text
                          id="lastName"
                          :error="errors.lastName"
                          :value="values.lastName"
                          :placeholder="'姓'"
                          name="lastName"
                          :text-error="textErrors.name"
                          :is-show-error="false"
                          :is-required="true"
                          @onHandleChange="onHandleChange"
                          @onValidate="onValidate"
                        ></input-text>
                      </li>
                      <li>
                        <input-text
                          id="firstName"
                          :error="errors.firstName"
                          :value="values.firstName"
                          :placeholder="'名'"
                          name="firstName"
                          :text-error="textErrors.name"
                          :is-show-error="false"
                          :is-required="true"
                          @onHandleChange="onHandleChange"
                          @onValidate="onValidate"
                        ></input-text>
                      </li>
                    </ul>
                    <error-message v-if="errors.firstName" :error="errors.firstName">
                    </error-message>
                    <error-message
                      v-else-if="errors.lastName"
                      :error="errors.lastName"
                    ></error-message>
                  </dd>
                  <dt>フリガナ</dt>
                  <dd>
                    <ul class="input-area">
                      <li>
                        <input-text
                          id="lastNameKana"
                          :error="errors.lastNameKana"
                          :value="values.lastNameKana"
                          :placeholder="'セイ'"
                          name="lastNameKana"
                          :text-error="textErrors.nameKana"
                          :is-show-error="false"
                          :is-required="true"
                          :pattern="regexKana"
                          @onHandleChange="onHandleChange"
                          @onValidate="onValidate"
                        ></input-text>
                      </li>
                      <li>
                        <input-text
                          id="firstNameKana"
                          :error="errors.firstNameKana"
                          :value="values.firstNameKana"
                          :placeholder="'メイ'"
                          name="firstNameKana"
                          :text-error="textErrors.nameKana"
                          :is-show-error="false"
                          :is-required="true"
                          :pattern="regexKana"
                          @onHandleChange="onHandleChange"
                          @onValidate="onValidate"
                        ></input-text>
                      </li>
                    </ul>
                    <error-message v-if="errors.firstNameKana" :error="errors.firstNameKana">
                    </error-message>
                    <error-message
                      v-else-if="errors.lastNameKana"
                      :error="errors.lastNameKana"
                    ></error-message>
                  </dd>
                  <dt>生年月日</dt>
                  <dd>
                    <date-select
                      :values="{ year: values.year, month: values.month, date: values.date }"
                      :error="errors.date"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    ></date-select>
                    <error-message v-if="errors.date" :error="errors.date"></error-message>
                  </dd>
                  <dt>性別</dt>
                  <dd>
                    <ul :class="`radio-area ${errors.gender ? 'is-error' : ''}`">
                      <li>
                        <input
                          id="male"
                          v-model="values.gender"
                          type="radio"
                          name="gender"
                          value="1"
                          @click="onValidateGender()"
                        />
                        <label for="male"><span>男性</span></label>
                      </li>
                      <li>
                        <input
                          id="female"
                          v-model="values.gender"
                          type="radio"
                          name="gender"
                          value="2"
                          @click="onValidateGender()"
                        />
                        <label for="female"><span>女性</span></label>
                      </li>
                    </ul>
                    <p class="error-txt">{{ errors.gender }}</p>
                  </dd>
                  <dt>メールアドレス</dt>
                  <dd>
                    <input-email
                      name="email"
                      :value="values.email"
                      :error="errors.email"
                      :placeholder="'メールアドレス'"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-email>
                  </dd>
                  <dt>ご連絡先<span>※ハイフン無し</span></dt>
                  <dd>
                    <input-phone
                      name="phone"
                      :max-length="11"
                      placeholder="08012345678"
                      :value="values.phone"
                      :error="errors.phone"
                      :text-error="textErrors.phone"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-phone>
                  </dd>
                </dl>
                <p>
                  弊社は、ご提供いただいた個人情報を「
                  <a href="https://www.svenson.co.jp/privacy/" target="_blank">
                    個人情報の取扱について
                  </a>
                  」に記載している事項に沿って取り扱います。
                </p>
              </div>
            </div>

            <button-registration
              :is-prev-button="false"
              :next-text="'次へ'"
              :handle-next-button="nextStep"
            >
            </button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputText from '../common/InputText'
import ErrorMessage from '../common/ErrorMessage'
import * as errorMessage from '../../constant/text'
import * as regex from '../../helpers/regex'
import InputEmail from '../common/InputEmail'
import InputPhone from '../common/InputPhone'
import { rulesValidateAllReservation } from '../../helpers/schemaValidate'
import { scrollToTop } from '../../helpers'
import ButtonRegistration from '../common/ButtonRegistration'
import DateSelect from '../common/DateSelect'
import { createUser, updateUser } from '../../actions/requestReservation'

export default {
  name: 'ReservationProfile',
  components: {
    DateSelect,
    ButtonRegistration,
    InputPhone,
    InputEmail,
    ErrorMessage,
    InputText,
  },
  props: {
    currentStep: {
      type: String,
      default: '1',
    },
    isForceValidate: {
      type: Boolean,
      default: false,
    },
    values: {
      type: Object,
      default: () => {
        return {
          userId: '',
          firstName: '',
          lastName: '',
          firstNameKana: '',
          lastNameKana: '',
          gender: '',
          email: '',
          phone: '',
          year: '',
          month: '',
          date: '',
        }
      },
    },
  },
  data() {
    return {
      textErrors: {
        name: errorMessage.NAME_INVALID,
        nameKana: errorMessage.NAME_KANA_INVALID,
        phone: errorMessage.PHONE_INVALID,
      },
      errors: {
        firstName: '',
        lastName: '',
        firstNameKana: '',
        lastNameKana: '',
        email: '',
        gender: '',
        phone: '',
        date: '',
      },
      regexKana: regex.patternKana,
    }
  },
  watch: {
    isForceValidate(newVal) {
      if (newVal && this.currentStep === '1') {
        this.nextStep()
      }
    },
  },
  methods: {
    onHandleChange(field, value) {
      this.$emit('onHandleChange', field, value)
    },
    onValidate(field, value) {
      this.errors[field] = value
      this.$emit('onValidateSwipe', false)
    },
    onValidateGender() {
      this.errors.gender = ''
    },
    nextStep() {
      rulesValidateAllReservation
        .validate(this.values, { abortEarly: false })
        .then(() => {
          this.$emit('startLoading')
          if (this.values.userId) {
            updateUser(this.values.userId, this.values)
              .then(response => {
                const {
                  data: { success },
                } = response
                if (success && success === 1) {
                  const {
                    data: { data },
                  } = response
                  this.$emit('setUserId', data.id.toString())
                  this.$emit('nextToStep', '2')
                  this.$emit('endLoading')
                }
              })
              .catch(err => {
                const {
                  response: {
                    data: { error },
                  },
                } = err
                if (error.email) {
                  this.errors.email = 'すでに登録。 ログインしてください。'
                  this.$emit('endLoading')
                }
              })
          } else {
            createUser(this.values)
              .then(response => {
                const {
                  data: { success },
                } = response
                if (success && success === 1) {
                  const {
                    data: { data },
                  } = response
                  this.$emit('setUserId', data.id.toString())
                  this.$emit('nextToStep', '2')
                  this.$emit('endLoading')
                }
              })
              .catch(err => {
                const {
                  response: {
                    data: { error },
                  },
                } = err
                if (error.email) {
                  this.errors.email = 'すでに登録。 ログインしてください。'
                  this.$emit('endLoading')
                  this.$router.push({
                    name: 'reservation-error',
                  })
                }
              })
          }
        })
        .catch(err => {
          err.inner.forEach(error => {
            this.errors[error.path] = error.message
            this.$emit('endLoading')
          })
          scrollToTop()
        })
    },
  },
}
</script>

<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}
</style>
